(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".sticky-features");
    const wrapper = document.querySelector(".sticky-features_content-wrapper");
    const oddBlocks = document.querySelectorAll(".sticky-features_odd-col .sticky-features_feature-block");
    const evenBlocks = document.querySelectorAll(".sticky-features_even-col .sticky-features_feature-block");

    if (!section || !wrapper) return;

    let blocks = [];
    const maxLength = Math.max(oddBlocks.length, evenBlocks.length);
    for (let i = 0; i < maxLength; i++) {
      if (oddBlocks[i]) blocks.push(oddBlocks[i]);
      if (evenBlocks[i]) blocks.push(evenBlocks[i]);
    }

    const totalSteps = blocks.length;
    const windowH = window.innerHeight;
    if (window.innerWidth >= 768) {
      section.style.height = `${windowH * (totalSteps + 1)}px`;
    } else {
      section.style.height = "auto";
    }

    if (blocks[0]) {
      blocks[0].style.opacity = 1;
      blocks[0].style.transform = "translateY(0)";
      blocks[0].style.zIndex = 2;
    }

    const images = document.querySelectorAll(".sticky-features_featured-image");
    if (images[0]) {
      images[0].classList.add("active");
    }

    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY;
      const sectionTop = section.offsetTop;
      let sectionScroll = scrollY - sectionTop;

      if (sectionScroll < 0) sectionScroll = 0;

      if (sectionScroll <= windowH * totalSteps) {
        let step = Math.floor(sectionScroll / windowH);
        step = Math.max(0, Math.min(step, totalSteps - 1));
        const progress = (sectionScroll % windowH) / windowH;

        if (window.innerWidth > 575) {
          images.forEach((img, i) => {
            img.classList.toggle("active", i === step);
          });
        } else {
          if (progress > 0.5) {  
            images.forEach((img, i) => {
              img.classList.toggle("active", i === step);
            });
          }
        }

        blocks.forEach((block, i) => {
          if (i === step) {
            let translateY = windowH - (progress * 2 * windowH);
            let opacity;
            if (window.innerWidth <= 575) {
              opacity = 1;
            } else {
              if (i === 0) {
                if (progress < 0.7) {
                  opacity = 1;
                  translateY = 0;
                } else {
                  opacity = 1 - (progress - 0.7) / 0.4;
                  translateY = -(progress - 0.7) * windowH;
                }
              } else {
                if (progress < 0.4) {
                  opacity = progress / 0.4;
                } else if (progress > 0.7) {
                  opacity = 1 - (progress - 0.7) / 0.4;
                } else {
                  opacity = 1;
                }
              }
            }

            block.style.opacity = opacity;
            block.style.transform = `translateY(${translateY}px)`;
            block.style.zIndex = 2;
          } else {
            block.style.opacity = 0;
            block.style.transform = `translateY(${windowH}px)`;
            block.style.zIndex = 1;
          }
        });
      }
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".sticky-features_feature-block-mobile");
    const images = document.querySelectorAll(".sticky-features_featured-image-mobile");

    if (!cards.length || !images.length) return;

    images.forEach((img, i) => {
      img.style.display = i === 0 ? "block" : "none";
    });

    if (cards[0]) {
      cards[0].classList.add("active-card");
    }

    cards.forEach((card, index) => {
      card.addEventListener("click", () => {
        images.forEach(img => (img.style.display = "none"));

        cards.forEach(c => c.classList.remove("active-card"));

        if (images[index]) {
          images[index].style.display = "block";

          images[index].scrollIntoView({
            behavior: "smooth",
            block: "center" 
          });
        }

        card.classList.add("active-card");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-section"] && !Shopify.designMode) return;
  try {
    
// Any JavaScript functionality can be added here if needed

  } catch(e) { console.error(e); }
})();
})();
